export enum ActionButtonClasses {
  Add = 'btn-primary',
  Remove = 'btn-danger'
}

export enum ActionIconClasses {
  Add = 'f-i-plus-circle',
  Remove = 'f-i-minus-circle'
}
